// src/pages/RadiantIsleRH.js
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function NosepassCave() {
  React.useEffect(() => {
    document.title = "Nosepass Cave | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.nosepassCave} />;
}
